import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 논리 그룹 트리를 조회한다.
   * @author Ju
   * @param  {Boolean} showEmptyGroup 빈그룹 표현 여부
   * @return {Array} 트리 배열 객체
   */
  getLogicalGroupTree(showEmptyGroup) {
    return axios.get(`${baseUrl}/settings/common/logical-group/get-logical-group-tree.do`, {
      params: {
        showEmptyGroup,
      },
    });
  },
  /**
   * 파라미터로 전달한 그룹 아이디를 가진 그룹의 관리 대상 목록을 조회한다.
   * @author Ju
   * @param  {Number} managegroupId 논리 그룹 아이디
   */
  getObjListOfGroup(managegroupId) {
    return axios.get(`${baseUrl}/settings/common/logical-group/get-obj-list-of-group.do`, {
      params: {
        managegroupId,
      },
    });
  },
  /**
   * 논리 그룹의 관리 대상 구성을 갱신한다.
   *
   * @author Ju
   * @param  {Object} params { INSERT: [{managegroupId, objId, orderbyIndex}..],
   *                           UPDATE: [{managegroupId, objId, orderbyIndex}..],
   *                           DELETE: [{managegroupId, objId,}..] }
   */
  updateManageGrpObj(params) {
    return axios.post(`${baseUrl}/settings/common/logical-group/update-managegrp-obj.do`, params);
  },

  /**
   * 논리 그룹 정보를 갱신한다.
   *
   * @author Ju
   * @param  {Object} params { INSERT: [{managegroupId, managegroupName, orderbyIndex, parentManagegroupId}..],
   *                           UPDATE: [{managegroupId, managegroupName, orderbyIndex, parentManagegroupId}..],
   *                           DELETE: [{managegroupId,}..] }
   */
  updateManagegrp(params) {
    return axios.post(`${baseUrl}/settings/common/logical-group/update-managegrp.do`, params);
  },
  /**
   * 현재 관리 대상에 설정된 관리 구분별 장비 종류 목록을 반환한다.
   * @author Ju
   * @param  {[type]} managetypeId [description]
   * @return {[type]}              [description]
   */
  getUsingObjtypeList(managetypeId) {
    return axios.get(`${baseUrl}/settings/common/logical-group/get-using-objtype-list.do`, {
      params: {
        managetypeId,
      },
    });
  },
  /**
   * 현재 관리 대상에 설정된 관리 구분별 벤더 목록을 반환한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}              [description]
   */
  getUsingObjCompanyList(params) {
    return axios.post(`${baseUrl}/settings/common/logical-group/get-using-obj-company-list.do`, params);
  },
  getUsingVirtualcenterList() {
    return axios.get(`${baseUrl}/settings/common/logical-group/get-using-virtualcenter-list.do`);
  },
  getPhysicalObjList(params) {
    return axios.post(`${baseUrl}/settings/common/logical-group/get-physical-obj-list.do`, params);
  },
  /**
   * 관리대상 논리그룹 장비 리스트를 조회
   * @author najong
   * @param  {[type]} managetypeId [description]
   * @return {[type]}              [description]
   */
  getLogicalObjList(params) {
    return axios.post(`${baseUrl}/settings/common/logical-group/get-logical-obj-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/logical-group.js